/**
 * Save generated text (exports, task lists) as a file. CSV files get a UTF-8
 * byte-order mark so Excel opens accented characters correctly.
 */
export const downloadTextFile = (filename: string, content: string, mimeType = 'text/plain;charset=utf-8') => {
  const needsBom = /csv/i.test(mimeType) && !content.startsWith('﻿');
  const blob = new Blob([needsBom ? `﻿${content}` : content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Revoke after the click has been handled; revoking synchronously can
  // cancel the download in some browsers.
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
};

/** Start a download from a URL the browser can fetch directly. */
export const downloadFromUrl = (url: string, filename?: string) => {
  const link = document.createElement('a');
  link.href = url;
  if (filename) link.download = filename;
  link.rel = 'noopener';
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/**
 * A PithPlay media link that downloads under `fileName` (the API sends it as
 * an attachment with that name) instead of opening in the browser. Links the
 * API didn't sign come back unchanged.
 */
export const namedDownloadUrl = (url: string, fileName?: string | null): string => {
  if (!url || !fileName) return url;
  try {
    const parsed = new URL(url);
    if (!parsed.pathname.startsWith('/api/assets/')) return url;
    parsed.searchParams.set('download', fileName);
    return parsed.toString();
  } catch {
    return url;
  }
};
